import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import headerImage from "../../../assets/images/profile/pic1.jpg";
import { MdDashboard } from "react-icons/md";
import { AiFillFlag } from "react-icons/ai";
import { BiBookOpen } from "react-icons/bi";
import { GoVerified } from "react-icons/go";
import { FaAffiliatetheme, FaQuestion } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const SidebarTest = () => {
  const [openSideNav, setOpenSideNav] = useState(false);
  const { pathname } = useLocation();
  const [adminDetails, setAdminDetails] = useState({});
  const details = useSelector((state) => state.adminDetails);

  useEffect(() => {
    if (
      pathname === "/admin/users" ||
      pathname === "/admin/new-user" ||
      pathname === "/admin/edit-user"
    ) {
      setOpenSideNav(true);
    }
  }, [pathname]);

  useEffect(() => {
    setAdminDetails(details.data);
  }, [details]);

  return (
    <React.Fragment>
      <div className="dlabnav">
        <div className="dlabnav-scroll">
          <div className="dropdown header-profile2 ">
            <a
              className="nav-link "
              href="#sidebar"
              role="button"
              data-bs-toggle="dropdown"
            >
              <div className="header-info2 d-flex align-items-center">
                {adminDetails && adminDetails.profile && (
                  <img
                    src={process.env.REACT_APP_IMAGE_URL + "profile-images/" + adminDetails.profile}
                    alt={adminDetails.name}
                  />
                )}
                {!adminDetails ||
                  (adminDetails.profile === "" && (
                    <img src={headerImage} alt={adminDetails.name} />
                  ))}
                <div className="d-flex align-items-center sidebar-info">
                  <div>
                    <span className="font-w400 d-block">
                      {adminDetails.name}
                    </span>
                    <small className="text-end font-w400">Superadmin</small>
                  </div>
                </div>
              </div>
            </a>
          </div>
          {/* // Optional
            // elemBefore: () => <Icon name="calendar" /> */}

          <div style={{ paddingTop: "0.9375rem" }} id="sidebar-nav-main">
            <Sidebar width="100%">
              <Menu
                menuItemStyles={{
                  button: ({ level, active, disabled }) => {
                    // only apply styles on first level elements of the tree
                    if (level === 1)
                      return {
                        color: disabled ? "#c72e09" : "#000000",
                        backgroundColor: active ? "red" : undefined,
                      };
                  },
                }}
              >
                {pathname === "/admin/dashboard" ? (
                  <MenuItem
                    icon={<MdDashboard />}
                    routerLink={<Link to="/admin/dashboard" />}
                    active={true}
                  >
                    Dashboard
                  </MenuItem>
                ) : (
                  <MenuItem
                    icon={<MdDashboard />}
                    routerLink={<Link to="/admin/dashboard" />}
                  >
                    Dashboard
                  </MenuItem>
                )}
                <SubMenu
                  label="Users"
                  icon={<AiFillFlag />}
                  open={openSideNav}
                  onOpenChange={(open) => {
                    if (open) {
                      setOpenSideNav(open);
                    } else {
                      setOpenSideNav(open);
                    }
                  }}
                >
                  {pathname === "/admin/users" ? (
                    <MenuItem
                      routerLink={<Link to="/admin/users" />}
                      active={true}
                    >
                      User List
                    </MenuItem>
                  ) : (
                    <MenuItem routerLink={<Link to="/admin/users" />}>
                      User List
                    </MenuItem>
                  )}
                  {pathname === "/admin/new-user" ? (
                    <MenuItem
                      routerLink={<Link to="/admin/new-user" />}
                      active={true}
                    >
                      Add User
                    </MenuItem>
                  ) : (
                    <MenuItem routerLink={<Link to="/admin/new-user" />}>
                      Add User
                    </MenuItem>
                  )}
                  {pathname === "/admin/deleted-users" ? (
                    <MenuItem
                      routerLink={<Link to="/admin/deleted-users" />}
                      active={true}
                    >
                      Deleted Users
                    </MenuItem>
                  ) : (
                    <MenuItem routerLink={<Link to="/admin/deleted-users" />}>
                      Deleted Users
                    </MenuItem>
                  )}
                </SubMenu>

                {pathname === "/admin/verification-requests" ? (
                  <MenuItem
                    icon={<GoVerified />}
                    routerLink={<Link to="/admin/verification-requests" />}
                    active={true}
                  >
                    Verification Requests
                  </MenuItem>
                ) : (
                  <MenuItem
                    icon={<GoVerified />}
                    routerLink={<Link to="/admin/verification-requests" />}
                  >
                    Verification Requests
                  </MenuItem>
                )}

                {pathname === "/admin/themes" ? (
                  <MenuItem
                    icon={<FaAffiliatetheme />}
                    routerLink={<Link to="/admin/themes" />}
                    active={true}
                  >
                    Themes
                  </MenuItem>
                ) : (
                  <MenuItem
                    icon={<FaAffiliatetheme />}
                    routerLink={<Link to="/admin/themes" />}
                  >
                    Themes
                  </MenuItem>
                )}

                {pathname === "/admin/cms-pages" ? (
                  <MenuItem
                    icon={<BiBookOpen />}
                    routerLink={<Link to="/admin/cms-pages" />}
                    active={true}
                  >
                    CMS Page
                  </MenuItem>
                ) : (
                  <MenuItem
                    icon={<BiBookOpen />}
                    routerLink={<Link to="/admin/cms-pages" />}
                  >
                    CMS Page
                  </MenuItem>
                )}

                {pathname === "/admin/faqs" ? (
                  <MenuItem
                    icon={<FaQuestion />}
                    routerLink={<Link to="/admin/faqs" />}
                    active={true}
                  >
                    Faq's
                  </MenuItem>
                ) : (
                  <MenuItem
                    icon={<FaQuestion />}
                    routerLink={<Link to="/admin/faqs" />}
                  >
                    Faq's
                  </MenuItem>
                )}
              </Menu>
            </Sidebar>
          </div>
          <div className="copyright">
            <p>
              <strong>Nexuslink Admin</strong> © 2023 All Rights Reserved
            </p>
            <p className="fs-12">
              Made with <span className="heart" /> by Nexus Team
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SidebarTest;
